import { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import SEO from '../../components/SEO';

const CompliancePage = () => {
    return (
        <Fragment>
            <SEO 
                title="POTRAZ & Data Protection Compliance | Wilson Tamuka Attorneys Zimbabwe"
                description="Wilson Tamuka Attorneys' commitment to POTRAZ regulations and Zimbabwe Cyber and Data Protection Act compliance. Learn about our data protection officer and security measures."
                keywords="POTRAZ compliance Zimbabwe, data protection officer Zimbabwe, Cyber and Data Protection Act, DPO Zimbabwe, data security Zimbabwe, legal compliance Zimbabwe"
                canonical="https://wtafirm.co.zw/compliance"
            />
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'}/>
            <PageTitle pageTitle={'Regulatory Compliance'} pagesub={'POTRAZ & Data Protection Compliance'} />
            <section className="wpo-terms-section section-padding">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 offset-lg-1">
                            <div className="wpo-terms-wrap">
                                <div className="wpo-terms-text">
                                    <h2>POTRAZ and Data Protection Compliance</h2>
                                    <p>Wilson Tamuka Attorneys (WTA) is committed to full compliance with Zimbabwe's regulatory framework for data protection and telecommunications, including the Postal and Telecommunications Regulatory Authority of Zimbabwe (POTRAZ) regulations and the Cyber and Data Protection Act.</p>

                                    <h3>1. Data Protection Officer (DPO)</h3>
                                    <p>In accordance with POTRAZ requirements and the Cyber and Data Protection Act, Wilson Tamuka Attorneys has designated a Data Protection Officer responsible for:</p>
                                    <ul>
                                        <li>Overseeing data protection strategy and implementation</li>
                                        <li>Ensuring compliance with Zimbabwe's data protection laws</li>
                                        <li>Monitoring internal compliance and conducting audits</li>
                                        <li>Serving as the point of contact for data subjects and regulatory authorities</li>
                                        <li>Advising on data protection impact assessments</li>
                                        <li>Cooperating with POTRAZ and other regulatory bodies</li>
                                    </ul>

                                    <h3>2. Compliance with Zimbabwe Cyber and Data Protection Act</h3>
                                    <p>We adhere to all provisions of the Cyber and Data Protection Act, including:</p>
                                    <ul>
                                        <li><strong>Lawful Processing:</strong> Processing personal data lawfully, fairly, and transparently</li>
                                        <li><strong>Purpose Limitation:</strong> Collecting data only for specified, explicit, and legitimate purposes</li>
                                        <li><strong>Data Minimization:</strong> Ensuring data collected is adequate, relevant, and limited to what is necessary</li>
                                        <li><strong>Accuracy:</strong> Maintaining accurate and up-to-date personal data</li>
                                        <li><strong>Storage Limitation:</strong> Retaining data only as long as necessary for the purposes collected</li>
                                        <li><strong>Security:</strong> Implementing appropriate technical and organizational measures</li>
                                        <li><strong>Accountability:</strong> Demonstrating compliance with data protection principles</li>
                                    </ul>

                                    <h3>3. POTRAZ Registration and Compliance</h3>
                                    <p>Wilson Tamuka Attorneys maintains compliance with POTRAZ regulations regarding:</p>
                                    <ul>
                                        <li>Data controller registration with POTRAZ</li>
                                        <li>Annual compliance reporting and audits</li>
                                        <li>Data breach notification protocols</li>
                                        <li>Cross-border data transfer regulations</li>
                                        <li>Consumer data protection standards</li>
                                    </ul>

                                    <h3>4. Data Security Measures</h3>
                                    <p>We implement comprehensive security measures including:</p>
                                    <ul>
                                        <li>Encryption of sensitive data in transit and at rest</li>
                                        <li>Access controls and authentication mechanisms</li>
                                        <li>Regular security assessments and vulnerability testing</li>
                                        <li>Incident response and data breach management procedures</li>
                                        <li>Staff training on data protection and cyber security</li>
                                        <li>Secure disposal of data when no longer required</li>
                                    </ul>

                                    <h3>5. Data Subject Rights</h3>
                                    <p>In compliance with Zimbabwe's data protection framework, we respect and facilitate:</p>
                                    <ul>
                                        <li><strong>Right to Access:</strong> Individuals can request access to their personal data</li>
                                        <li><strong>Right to Rectification:</strong> Correction of inaccurate or incomplete data</li>
                                        <li><strong>Right to Erasure:</strong> Deletion of personal data (subject to legal obligations)</li>
                                        <li><strong>Right to Object:</strong> Objection to processing of personal data</li>
                                        <li><strong>Right to Data Portability:</strong> Receiving personal data in a structured format</li>
                                        <li><strong>Right to Lodge Complaints:</strong> Filing complaints with POTRAZ or relevant authorities</li>
                                    </ul>

                                    <h3>6. Data Breach Response</h3>
                                    <p>We maintain a comprehensive data breach response protocol:</p>
                                    <ul>
                                        <li>Immediate containment and assessment of breaches</li>
                                        <li>Notification to POTRAZ within 72 hours of becoming aware of a breach</li>
                                        <li>Communication to affected data subjects without undue delay</li>
                                        <li>Documentation and investigation of all incidents</li>
                                        <li>Implementation of remedial measures to prevent recurrence</li>
                                    </ul>

                                    <h3>7. Third-Party Data Processors</h3>
                                    <p>When engaging third-party service providers who process personal data on our behalf:</p>
                                    <ul>
                                        <li>We conduct due diligence on their data protection practices</li>
                                        <li>Execute data processing agreements with appropriate safeguards</li>
                                        <li>Ensure they comply with Zimbabwe's data protection requirements</li>
                                        <li>Monitor their compliance through regular audits</li>
                                    </ul>

                                    <h3>8. Cross-Border Data Transfers</h3>
                                    <p>For international data transfers, we ensure:</p>
                                    <ul>
                                        <li>Compliance with POTRAZ cross-border data transfer regulations</li>
                                        <li>Adequate protection mechanisms are in place</li>
                                        <li>Appropriate contractual safeguards with international partners</li>
                                        <li>Notification to POTRAZ where required</li>
                                    </ul>

                                    <h3>9. Client Data Protection</h3>
                                    <p>As a law firm, we maintain enhanced protection for client data:</p>
                                    <ul>
                                        <li>Attorney-client privilege protections</li>
                                        <li>Professional confidentiality obligations under Law Society of Zimbabwe rules</li>
                                        <li>Secure client portals and communication channels</li>
                                        <li>Restricted access to client files on a need-to-know basis</li>
                                    </ul>

                                    <h3>10. Continuous Compliance</h3>
                                    <p>We are committed to maintaining ongoing compliance through:</p>
                                    <ul>
                                        <li>Regular policy reviews and updates</li>
                                        <li>Staff training and awareness programs</li>
                                        <li>Internal audits and compliance assessments</li>
                                        <li>Monitoring changes in legislation and regulatory guidance</li>
                                        <li>Engagement with POTRAZ and other regulatory bodies</li>
                                    </ul>


                                    <p>You have the right to lodge a complaint with POTRAZ if you believe your data protection rights have been violated.</p>

                                    <p><strong>Last Updated:</strong> December 2025</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default CompliancePage;
